import { FormControlLabel, Switch, Typography, Box } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import { styled } from "@mui/material/styles";
import { updateData } from "../Services/updateData";
import { endpoints } from "../Utils/UrlEnum";

export default function ActivateNotifications({
  notification,
  setNotification,
}: {
  notification: boolean;
  setNotification: (notification: boolean) => void;
}) {
  const NotificationSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 38,
    padding: 8,
    "& .MuiSwitch-switchBase": {
      padding: 7,
      "&.Mui-checked": {
        transform: "translateX(24px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 0.8,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 24,
      height: 24,
      backgroundColor: "#fff",
      boxShadow: theme.shadows[2],
    },
    "& .MuiSwitch-track": {
      borderRadius: 20,
      backgroundColor: theme.palette.grey[400],
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 300,
      }),
    },
  }));

  const clientId = localStorage.getItem("clientId");

  const submitChange = async () => {
    const newValue = !notification;
    await updateData(`${endpoints.client.main}/${clientId}`, {
      onlineLessonReminders: newValue,
    }).then((response) => {
      if (response && response.data) {
        setNotification(newValue);
      }
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
      }}
    >
      <FormControlLabel
        control={
          <NotificationSwitch
            checked={notification}
            onChange={() => submitChange()}
            color="primary"
          />
        }
        label={
          <Typography
            variant="h6"
            fontWeight={600}
            color="primary.dark"
            sx={{ ml: 1 }}
          >
            {Vocabulary.activateNotifications}
          </Typography>
        }
        sx={{ m: 0 }}
      />
    </Box>
  );
}
